<script setup>
import AlarmComponent from '@/components/AlarmComponent.vue';
import ConfirmComponent from '@/components/ConfirmComponent.vue';
import PreviewPanel from '@/components/SingleFileViewComponent.vue';
import ToastComponent from '@/components/ToastComponent.vue'; //
import UserComponent from '@/components/UserComponent.vue';
import { useAuthStore } from '@/store/auth-store';
import { useMenuStore } from '@/store/menu-store';
import { useNotificationStore } from '@/store/notification-store';
import { useRouterStore } from '@/store/router-store';
import { useSidebarStore } from '@/store/sidebar-store';
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
let BASE_URL = import.meta.env.VITE_APP_API_URL;
const isDevelopment = import.meta.env.VITE_APP_ENV === 'development';
const previewFile = ref({
    url: '',
    type: ''
});

const sidebarStore = useSidebarStore();
const alarmComponentRef = ref(null);
const alarmState = ref(0);
const userComponentRef = ref(null);
const routerStore = useRouterStore();
const menuStore = useMenuStore();
const toastComponentRef = ref(null);
const authStore = useAuthStore();
const userNameRef = computed(() => authStore.getUserName);
const userIdRef = computed(() => authStore.getUserId);
const userLoginIdRef = computed(() => authStore.getUserLoginId);
const notificationStore = useNotificationStore();
const confirmAction = ref(null);
const showConfirmDialog = ref(false);
const dialogHeader = ref('');
const dialogMessage = ref('');
const dialogcomplete = ref('');
let isConfirming = false;
let timerInterval;
const startTimer = () => {
    const now = new Date();
    const nextInterval = new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours() + 1, 0, 0, 0);
    const delay = nextInterval.getTime() - now.getTime();

    setTimeout(() => {
        const time = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;
        messageAlarm('테스트', `정각 알림 (타이머 테스트)\n현재 시간 : ${time}`);
        timerInterval = setInterval(messageAlarm, 60 * 60 * 2000);
    }, delay);
};

onMounted(() => {
    console.log(alarmComponentRef.value.readState);

    watch(
        () => alarmComponentRef.value?.readState,
        (newVal) => {
            alarmState.value = !newVal === true ? 0 : newVal;
        },
        { immediate: true }
    );

    notificationStore.setMessageCallback((notification) => {
        try {
            messageAlarm(notification.title, notification.body);
        } catch (error) {
            console.error('알람 처리 중 오류 발생:', error);
        } finally {
            setTimeout(() => {
                if (!notificationStore.isConnected) {
                    // 연결이 끊어진 경우에만 재연결 시도
                    console.log('WebSocket 재연결 시도...');
                    notificationStore.initializeWebSocket();
                }
            }, 5000);
        }
    });
});

onUnmounted(() => {
    if (timerInterval) clearInterval(timerInterval);
});

const onAlarmButtonClick = () => {
    // if (toastComponentRef.value) {
    //     toastComponentRef.value.showToastAlarm('알람 기능은 개발 중 입니다.');
    //     return;
    // }

    //API불러와서 리스트 전달
    let state = alarmComponentRef.value.readState;
    if (alarmComponentRef.value) {
        if (alarmComponentRef.value.isVisible) {
            alarmComponentRef.value.closePopup();
        } else {
            if (userComponentRef.value) userComponentRef.value.closePopup();
            alarmComponentRef.value.openPopup();
        }
    }
};

const onUserButtonClick = () => {
    if (userComponentRef.value) {
        if (userComponentRef.value.isVisible) {
            userComponentRef.value.closePopup();
        } else {
            if (alarmComponentRef.value) alarmComponentRef.value.closePopup();
            userComponentRef.value.openPopup();
        }
    }
};

const closePreview = () => {
    previewFile.value = { url: '', type: '', downurl: '' };
};

const onInfoButtonClick = async () => {
    try {
        previewFile.value = {
            url: `${BASE_URL}/view/common/DOCS/MANAGER_MANUAL`,
            type: 'application/pdf',
            downurl: `${BASE_URL}/download/common/DOCS/MANAGER_MANUAL`
        };

        //console.log(previewFile.value);
    } catch (error) {
        console.error('Error previewing file:', error);
        toastComponentRef.value?.showToast('error', '알림', '파일 미리보기 중 오류가 발생했습니다.');
    }
};

const messageAlarm = (title, body) => {
    const now = new Date();

    // const message = body;

    // notificationStore.addNotification({
    //     id: Date.now(),
    //     message: message,
    //     type: 'info'
    // });

    if (toastComponentRef.value) {
        toastComponentRef.value.showToastAlarm(title, body);
    }
    // if (toastComponentRef.value) {
    //     const now = new Date();
    //     const hours = String(now.getHours()).padStart(2, '0');
    //     const minutes = String(now.getMinutes()).padStart(2, '0');
    //     const seconds = String(now.getSeconds()).padStart(2, '0');
    //     const time = `${hours}:${minutes}:${seconds}`;
    //     toastComponentRef.value.showToastAlarm('정각 알림 (타이머 테스트)\n현재 시간 : ' + time);
    // }
};

const topbarStyle = computed(() => ({
    marginLeft: sidebarStore.isSidebarActive ? '22rem' : '0',
    width: sidebarStore.isSidebarActive ? 'calc(100% - 22.5rem)' : '100%'
}));

const tabbarStyle = computed(() => ({
    marginLeft: sidebarStore.isSidebarActive ? '0' : '17rem'
}));

const showMenuTab = computed(() => {
    return !(routerStore.currentPath === '/' || routerStore.currentPath === '/dashboard');
});

const totalTabCount = computed(() => menuStore.openTabs.length);
watch(totalTabCount, (newCount) => {
    // if (newCount > 12) {
    //     if (toastComponentRef.value) {
    //         toastComponentRef.value.showToast('', '알림', '탭은 12개까지 등록할 수 있습니다.');
    //     }
    // }
});

const setDialogInfo = (action) => {
    confirmAction.value = action;
    dialogHeader.value = dialogInfo[action].header;
    dialogMessage.value = dialogInfo[action].message;
    dialogcomplete.value = dialogInfo[action].completemessage;
};

const dialogInfo = {
    logout: {
        header: '로그아웃',
        message: '로그아웃 하시겠습니까?',
        completemessage: '로그아웃 되었습니다.'
    }
};

const handleLogout = async () => {
    try {
        setDialogInfo('logout');
        showConfirmDialog.value = true;
        // router.push('/login');
    } catch (error) {
        console.error('Logout failed:', error);
    }
};

const handleConfirm = async () => {
    if (isConfirming) return;
    isConfirming = true;

    try {
        switch (confirmAction.value) {
            case 'logout':
                await authStore.logout();
                break;
            default:
                break;
        }

        if (toastComponentRef.value) {
            toastComponentRef.value.showToast('success', dialogHeader.value, dialogcomplete.value);
        }
    } catch (error) {
        console.error('Confirmation error:', error);
        if (toastComponentRef.value) {
            toastComponentRef.value.showToast('error', dialogHeader.value, '로그아웃 실패하였습니다.');
        }
    } finally {
        setTimeout(() => {
            isConfirming = false;
            showConfirmDialog.value = false;
        }, 500);
    }
};

const handleCancel = () => {
    if (isConfirming) return;
    showConfirmDialog.value = false;
};
</script>

<template>
    <div class="topbar" :style="topbarStyle">
        <div class="left-section">
            <button class="hamburger-button" @click="sidebarStore.toggleSidebar">
                <i class="pi pi-bars"></i>
            </button>
            <div class="logo-container">
                <router-link to="/">
                    <img src="/image/gomduri_icon/ic_text_logo.png" alt="Logo" class="logo-image" />
                </router-link>
            </div>
        </div>

        <div v-if="showMenuTab" class="tab-container" :style="tabbarStyle">
            <div class="tab-scroll-container">
                <slot name="tabs"></slot>
            </div>
        </div>

        <div class="action-buttons">
            <span class="userinfo">
                <span class="mr-2">환영합니다.</span> [<span class="userinfo2 px-1.5">{{ userNameRef }}</span
                >]<span class="ml-2 mr-3">님</span>
                <button class="logout-button" @click="handleLogout()" aria-label="로그아웃">
                    <i class="pi pi-sign-out text-gray-700 hover:text-gray-900"></i>
                </button>
            </span>
            <button v-if="!isDevelopment" class="action-button" @click="onInfoButtonClick">
                <i class="pi pi-info-circle"></i>
            </button>
            <button class="action-button" @click="onAlarmButtonClick">
                <i class="pi pi-bell"></i>
                <!-- {{ alarmState }} -->
                <span v-if="typeof alarmState === 'number' && alarmState > 0" class="notification-count">
                    {{ alarmState }}
                </span>
                <!-- <i class="pi pi-bell"></i>
                <span class="notification-count"></span> -->
            </button>
            <button class="action-button" @click="onUserButtonClick">
                <i class="pi pi-user"></i>
            </button>
        </div>

        <UserComponent ref="userComponentRef" class="user-component" />
        <ConfirmComponent v-model:visible="showConfirmDialog" :dialogHeader="dialogHeader" :dialogMessage="dialogMessage" dialogIcon="pi pi-exclamation-triangle" dialogButtonSeverity="danger" @confirm="handleConfirm" @cancel="handleCancel" />
        <AlarmComponent ref="alarmComponentRef" class="alarm-component" />
        <ToastComponent ref="toastComponentRef" />
        <PreviewPanel v-if="previewFile.url" :fileUrl="previewFile.url" :fileType="previewFile.type" :downurl="previewFile.downurl" :width="'65rem'" :height="'60rem'" @close="closePreview" />
    </div>
</template>

<style scoped>
.topbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1rem;

    border-bottom: 0.1rem solid #ddd;
    background-color: #fff;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    transition:
        margin-left 0.3s ease-in-out,
        width 0.3s ease-in-out;
}

.userinfo {
    font-family: 'SCoreDream400';
    margin-right: 3.5rem;
    font-size: 0.875rem;
    color: #5f6368;
    display: flex;
}

.logout-button {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    line-height: 1;
}

.logout-button i {
    font-size: 0.8rem;
}

.userinfo2 {
    font-family: 'SCoreDream400';
    font-size: 0.875rem;
    color: #0038ea;
}

.left-section {
    display: flex;
    align-items: center;
}

.tab-container {
    position: relative; /* 중요: 일반적인 흐름에 위치 */
    display: flex;
    flex-grow: 1; /* 가로로 확장 가능 */
    margin: 0 2rem; /* 좌우 여백 */
    overflow: hidden; /* 가로 스크롤 */
    /* 최대 너비 계산: 전체 너비 - 사이드바 너비 - 로고 컨테이너 너비 - 액션 버튼 너비 - 여백 */
    max-width: calc(100% - var(--sidebar-width, 0px) - var(--logo-container-width, 12rem) - var(--action-buttons-width, 15rem) - 2rem); /* 필요에 따라 값 조정 */
    transition: max-width 0.5s ease-in-out;
}

.tab-scroll-container {
    overflow-x: auto; /* 가로 스크롤 활성화 */
    white-space: nowrap; /* 탭 줄바꿈 방지 */
    display: flex; /* 내부 요소 정렬 */
    min-width: 0; /* flexbox 동작 보정 */
    -ms-overflow-style: none; /*IE/Edge 스크롤바 숨김 - 제거 */
    scrollbar-width: none; /*Firefox 스크롤바 숨김 - 제거 */
}

/* .tab-scroll-container::-webkit-scrollbar {
    width: 0.6rem;
    height: 0.6rem;
}

.tab-scroll-container::-webkit-scrollbar-track {
    background: white;
    margin: 0.1rem 0;
    border-radius: 1rem;
}

.tab-scroll-container::-webkit-scrollbar-thumb {
    background: #d7d7dd;
    border-radius: 1rem;
}

.tab-scroll-container::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
} */

.hamburger-button {
    position: fixed;
    left: 2rem;
    top: 1rem;
    background: none;
    border: none;
    cursor: pointer;
    z-index: 1000;
}
.logo-container {
    position: fixed;
    left: 5rem;
    top: 0.2rem;
    z-index: 1000;
}

.logo-image {
    height: 42px;
    width: 7.5rem;
    object-fit: contain;
}

.action-buttons {
    display: flex;
    align-items: center;
    margin-left: auto;
}

.action-button {
    background: none;
    border: none;
    cursor: pointer;
    border-radius: 50%;
    transition: background-color 0.3s ease;
    display: flex;
    justify-content: center;
    align-items: center;
}

.action-button:hover {
    color: #0038ea;
}

.action-button i {
    font-size: 1.1rem;
    padding-right: 1.5rem;
}

.notification-count {
    /* position: absolute;
    top: 0.8rem;
    background-color: red;
    padding: 0.2rem;
    border-radius: 50%; */
    position: absolute;
    top: 0.3rem;
    background-color: #ff7171;
    padding: 0.12rem;
    border-radius: 50%;
    font-size: 0.5rem;
    width: 1.1rem;
    height: 1.1rem;
}

@media (max-width: 768px) {
    .tab-container {
        display: none;
    }

    .userinfo {
        display: none;
    }

    .logo-image {
        width: 7.5rem;
    }
}
</style>
